import { useUserSession } from "@/hooks/use-user-session";

/**
 * Project name is now included in the shared get_my_context payload
 * (see useUserSession). No separate `projects` fetch — the value is
 * derived from the cached session, matching react-query's loading state.
 */
export function useProjectName() {
  const query = useUserSession();
  return {
    ...query,
    data: query.data?.projectName ?? null,
  } as ReturnType<typeof useUserSession> & { data: string | null };
}
